import React from 'react';
import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../contexts/AuthContext';

/**
 * AdminRoute wraps routes that require admin role.
 * Redirects non-admin users to /documents.
 */
const AdminRoute: React.FC = () => {
  const { userRoles, isLoading } = useAuth();
  const isAdmin = userRoles.includes('admin');

  // Wait for auth to load before checking roles
  if (isLoading) {
    return null;
  }

  if (!isAdmin) {
    return <Navigate to="/documents" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
